import { AxiosInstance } from "axios";
import { getBoardApiUrl } from "helpers";
import { SiveActionResult } from "models/SiveActionResult";
import { StandardMeetingDiffModel } from "models/StandardMeetingDiffModel";
import { StandardMeetingModel } from "models/StandardMeetingModel";

export class StandardMeetingApi {
  constructor(private axios: AxiosInstance) {}

  async getAll(signal?: AbortSignal) {
    const url = getBoardApiUrl("standard-meetings");
    const response = await this.axios.get<StandardMeetingModel[]>(url, { signal });
    return response.data;
  }

  async apply(meetingId: number, templateId: number) {
    if (!meetingId) throw new Error("meetingId is required");
    if (!templateId) throw new Error("templateId is required");
    const url = getBoardApiUrl(`standard-meetings/apply/${meetingId}/${templateId}`);
    const response = await this.axios.post<SiveActionResult>(url);
    return response.data;
  }

  async getPreview(meetingId: number, templateId: number) {
    if (!meetingId) throw new Error("meetingId is required");
    if (!templateId) throw new Error("templateId is required");
    if (templateId === -10 || templateId === -20) {
      throw new Error("Preview is not available for the selected template");
    }

    const url = getBoardApiUrl(`standard-meetings/preview/${meetingId}/${templateId}`);
    const response = await this.axios.get<StandardMeetingDiffModel>(url);
    return response.data;
  }
}
